/**
 * useVoiceInput — thin re-export of @boox/ui-foundation hook.
 * Injects api.post as the transcribeFn so the hook stays API-agnostic.
 */

import { api } from '@/lib/api';
import {
  useVoiceInput as _useVoiceInput,
  type UseVoiceInputOpts,
} from '@boox/ui-foundation';

export type { UseVoiceInputOpts } from '@boox/ui-foundation';

export function useVoiceInput(opts: Omit<UseVoiceInputOpts, 'transcribeFn'> = {}) {
  return _useVoiceInput({
    ...opts,
    transcribeFn: async (audioBase64, mimeType, lang, context) => {
      const res = await api.post<{ text: string }>('/voice/transcribe', {
        audio: audioBase64,
        mimeType,
        lang,
        role: context?.role,
        surface: context?.surface,
        profile: context?.profile,
        mode: context?.mode,
        engine: context?.engine,
        vocabularyHints: context?.vocabularyHints,
      });
      return res.text;
    },
  });
}
